/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosResponse, AxiosRequestConfig } from "axios";

// url is read from environment variable
export const pdApiUrl = process.env.REACT_APP_PD_API_URL || "http://localhost:58318/api";

export const pdApiGet = async (
  option: Api.OptionsGet,
  id?: string,
  filter = ""
): Promise<typeof response.data> => {
  const url = id ? `${pdApiUrl}/${option}/${id}` : `${pdApiUrl}/${option}${filter}`;
  const response = await axios.get(url);
  const token = response.headers["x-xsrf-token"];
  axios.defaults.headers.xsrfHeaderName = "X-XSRF-TOKEN";
  axios.defaults.headers.common["X-XSRF-TOKEN"] = token;
  axios.defaults.withCredentials = true;
  return response.data;
};

export const pdApiPut = async (
  option: Api.OptionsGrud,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  object: any,
  mediaType = "application/json"
): Promise<Api.AnyItem> => {
  const id = object.id ?? object.boardTypeId ?? object.enumValue ?? object.value ?? object.locale ?? object.enumID;
  const url = `${pdApiUrl}/${option}/${id}`;
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": mediaType
    }
  };
  const response = await axios.put(url, object, config);
  return response.data;
};

export const pdApiPost = async (
  option: Api.OptionsGrud,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  object: any,
  mediaType = "application/json"
): Promise<any> => {
  const url = `${pdApiUrl}/${option}/`;
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": mediaType
    }
  };
  const response: AxiosResponse<any> = await axios.post(url, object, config);
  return response.data;
};

export const pdApiPostBindings = async (
  option: Api.OptionsGrud,
  type: string,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  object: any,
  mediaType = "application/json"
): Promise<any> => {
  const url = `${pdApiUrl}/${option}/${type}`;
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": mediaType
    }
  };
  const response: AxiosResponse<any> = await axios.post(url, object, config);
  return response.data;
};

export const pdApiDelete = async (option: Api.OptionsGrud, id: number | string): Promise<any> => {
  const url = `${pdApiUrl}/${option}/${id}`;
  const response: AxiosResponse<any> = await axios.delete(url);
  return response.data;
};

export const pdApiDownload = async (
  option: Api.OptionsGet,
  id?: string,
  filter = ""
): Promise<any> => {
  const url = id ? `${pdApiUrl}/${option}/${id}` : `${pdApiUrl}/${option}${filter}`;
  const response: AxiosResponse<any> = await axios({
    url,
    method: "GET",
    responseType: "blob"
  });
  return response.data;
};
